import data from "./missionTemplateCollection.json";

export type MissionTemplateEntry = Readonly<{
  sourceId: string;
  title: string;
  classification: "core workflow" | "worked example" | "AI simulation";
  category: string;
  audience: string;
  description: string;
  purpose: string;
  evidence: string;
  humanDecisions: string;
  qualifications: string;
  industryIds: readonly string[];
  relatedWorkflowIds: readonly string[];
  associatedExampleIds: readonly string[];
}>;

export const missionTemplateEntries = data.entries as readonly MissionTemplateEntry[];
export const missionTemplateCategories = data.categories;
export const curatedMissionTemplates = missionTemplateEntries.filter(e => e.classification !== "AI simulation");
export const missionTemplateSimulations = missionTemplateEntries.filter(e => e.classification === "AI simulation");
export const missionTemplateById = new Map(missionTemplateEntries.map(e => [e.sourceId, e]));
export const missionTemplateHref = (entry: MissionTemplateEntry) => `/resources/templates#${entry.sourceId}`;
